const CONTACT_EMAIL = "info@bokahundtrim.se";

export default CONTACT_EMAIL;
